import type { FunctionComponent } from 'react';

import { PlanSummary } from './PlanSummary';
import {
  usePlanSummaryCalculation,
  type PlanSummaryCalculationProps,
} from './usePlanSummaryCalculation';

export const PlanSummaryConnected: FunctionComponent<
  PlanSummaryCalculationProps
> = (props) => {
  const data = usePlanSummaryCalculation(props);
  return <PlanSummary {...data} />;
};
